/** Explain the actual catalog selection without implying personal diagnosis. */
export function dojoRecommendationExplanation(reason?: string | null, inProgress = false): string | null {
  if (inProgress) return 'Continue the practice you already started.';
  if (reason === 'review_due') return 'An earlier skill is due for another practice. Return to it with a fresh perspective.';
  if (reason === 'progression') return 'This is the next unfinished practice in the curriculum. You can choose another practice.';
  if (reason === 'catalog_default') return 'Revisit a practice from the library, or choose another to explore.';
  return null;
}
